import { cacheTypes, getMethod, postMethod, postMethodByDispatcher, putMethod } from "../../../store/api/CommonFunctions";

const BASE_URL = 'api/WorkItemsAPI';
/**
 * @typedef {Object} WorkItem
        * @property {number} AssignmentMode
        * @property {number} CategoryID
        * @property {Date} CompletedDate
        * @property {number} CreateByID
        * @property {string} CreateByName
        * @property {Date} CreationDate
        * @property {string} Description
        * @property {Date} DueDate
        * @property {number} EstimatedDurationMinutes
        * @property {number} ID
        * @property {string} Number
        * @property {number} Priority
        * @property {number} ProgressPercent
        * @property {number} Severity
        * @property {Date} StartDate
        * @property {number} StatusID
        * @property {number} StatusCode
        * @property {string} Status
        * @property {number} TagID
        * @property {string} Tag
        * @property {string} Title
        * @property {number} Type
        * @property {number} UpdateByID
        * @property {string} UpdateByName
        * @property {Date} UpdateDate
        * @property {bool} IsArchive
        * @property {number} ResponsibleUserID
        * @property {number} ExecutorUserID 
        * @property {number} ApproverUserID 
 */

/**
 * 
 * @param {WorkItem} data 
 * @returns 
 */
export const create = async (data) => {
    const result = await postMethod(`${BASE_URL}/Create`, data, "CREATE_WI");
    return result;
}
 /** 
 * @param {WorkItem} data 
 * @returns 
 */
export const update = async (data) => {
    const result = await putMethod(`${BASE_URL}/UpdateWorkItem`, data, "UPDATE_WI");
    return result;
}
/**
 * 
 * @param {number} id 
 * @returns {WorkItem}
 */
export const get = async (id) => {
    const result = await getMethod(`${BASE_URL}/GET?id=${id}`, cacheTypes.NoCache, "GET_WI");
    return result;
}
/**
 * 
 * @param {number} id 
 * @returns 
 */
export const changeArchiveStatus = async(id)=>{
    const result = await getMethod(`${BASE_URL}/ChangeArchiveStatus?id=${id}`, cacheTypes.NoCache,"ChangeArchiveStatus_WI");
    return result;
}
/**
 * 
 * @param {number} id 
 * @param {number} statusId 
 */
export const changeStatus = async (id, statusId)=>{
    const result = await getMethod(`${BASE_URL}/ChangeStatus?id=${id}&statusId=${statusId}`, cacheTypes.NoCache, "ChangeStatus_WI");
    return result;
}
export const search = (data)=>{
    return dispatch =>{
        dispatch({
            type:"WORKITEMS_SEARCH_FILTERS",
            data:data
        });
        dispatch(postMethodByDispatcher(`${BASE_URL}/Search`, data, "WorkItems_Search","جستجوی آیتم های کاری"));
    }
}
export const reportedByMe = (data)=>{
    return dispatch =>{
        dispatch({
            type:"WORKITEMS_REP_BY_ME_FILTERS",
            data:data
        });
        dispatch(postMethodByDispatcher(`${BASE_URL}/ReportedByMe`, data, "WorkItems_ReportedByMe","جستجوی آیتم های کاری"));
    }
}
export const referredToMe = (data)=>{
    return dispatch =>{
        dispatch({
            type:"WORKITEMS_REF_To_ME_FILTERS",
            data:data
        });
        dispatch(postMethodByDispatcher(`${BASE_URL}/ReferredToMe`, data, "WorkItems_ReferredToMe","جستجوی آیتم های کاری"));
    }
}
export const monitorByMe = (data)=>{
    return dispatch =>{
        dispatch({
            type:"WORKITEMS_Mon_BY_ME_FILTERS",
            data:data
        });
        dispatch(postMethodByDispatcher(`${BASE_URL}/MonitorByMe`, data, "WorkItems_MonitorByMe","فهرست پیگیری ها"));
    }
}
export const getWorkItemsBaseInfoes =async ()=>{
    const result = await getMethod(`${BASE_URL}/GetWorkItemsBaseInfoes`, cacheTypes.Default,"GetWorkItemsBaseInfoes");
    return result;
}
export const getByTypeAndNumber = async (type, number)=>{
    const result = await getMethod(`${BASE_URL}/GetByTypeAndNumber?type=${type}&number=${number}`);
    return result;
}
export const getNextNumber = async ()=>{
    const result = await getMethod(`${BASE_URL}/GetNextNumber`, cacheTypes.NoCache, "GetNextNumber");
    return result;
}
export const getProjectsForSelect =async (number)=>
{
    const result = await getMethod(`${BASE_URL}/getProjectsForSelect?number=${number}`, cacheTypes.NoCache,"GetProjectsForSelect");
    return result;
}